var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDadosUsuarioLogadoLocalStorage, getTokenFromCookie } from '../../services/mt_login';
import { PAGINAS, ROUTES } from '../../routes';
import { criptografar } from '../../utils';
var AuthContext = createContext({});
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(function () { return getDadosUsuarioLogadoLocalStorage(); }), User = _b[0], setUser = _b[1];
    var _c = useState([]), Mensagens = _c[0], setMensagens = _c[1];
    var DEV = useState(process.env.AMBIENTE === 'DEV')[0];
    var navigate = useNavigate();
    useEffect(function () { }, []);
    var auth = function (code, pagina, modo) {
        console.log('[AUTH-CTX] auth() — Pagina:', pagina, '| Modo:', modo, '| User:', !!User, '| Code:', !!code);
        if (User || code) {
            if (pagina === PAGINAS.HOME_PAINEL)
                return;
            var tokenAcesso = getTokenFromCookie();
            console.log('[AUTH-CTX] auth() — TokenAcesso presente:', !!tokenAcesso);
            if (!code && !tokenAcesso) {
                console.warn('[AUTH-CTX] Sem Code e sem Token — sessão expirada. Redirecionando para logout.');
                alert('Sessão expirada. Faça login novamente.');
                navigate(ROUTES.LOGOUT);
            }
            else {
                if (DEV)
                    return;
                var temPermissao = verificarPermissoesPagina(pagina || '', modo);
                console.log('[AUTH-CTX] auth() — temPermissao:', temPermissao, '| Pagina:', pagina, '| Modo:', modo);
                if (!temPermissao) {
                    console.warn('[AUTH-CTX] Sem permissão — redirecionando para /sem-permissao');
                    navigate(ROUTES.SEM_PERMISSAO);
                }
            }
        }
        else {
            console.warn('[AUTH-CTX] auth() — Sem User e sem Code — redirecionando para logout');
            navigate(ROUTES.LOGOUT);
        }
    };
    var signInContext = function (userParm) {
        var _a;
        console.log('[AUTH-CTX] signInContext chamado');
        console.log('[AUTH-CTX] Campos recebidos em userParm:', userParm ? Object.keys(userParm) : 'null/undefined');
        var id = userParm.id, access_token = userParm.access_token, nome = userParm.nome, cpf = userParm.cpf, email = userParm.email, matricula = userParm.matricula, funcionalidades_ajustadas = userParm.funcionalidades_ajustadas;
        console.log('[AUTH-CTX] Dados extraídos:', {
            id: id,
            nome: nome,
            email: email,
            matricula: matricula,
            possui_access_token: !!access_token,
            qtd_funcionalidades: (_a = funcionalidades_ajustadas === null || funcionalidades_ajustadas === void 0 ? void 0 : funcionalidades_ajustadas.length) !== null && _a !== void 0 ? _a : 0,
        });
        var usuario = {
            id: id,
            nome: nome,
            cpf: cpf,
            email: email,
            matricula: matricula,
            permissoes: funcionalidades_ajustadas,
        };
        localStorage.setItem('usuario_logado', criptografar(JSON.stringify(usuario)));
        console.log('[AUTH-CTX] usuario_logado salvo no localStorage');
        setTokenCookie(access_token);
        setUser(usuario);
        console.log('[AUTH-CTX] signInContext finalizado — usuário setado no contexto');
    };
    var setTokenCookie = function (token) {
        var days = 5;
        var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        console.log('[AUTH-CTX] setTokenCookie — LOCALHOST:', process.env.LOCALHOST, '| token presente:', !!token);
        if (process.env.LOCALHOST) {
            document.cookie = "token=".concat(token, "; expires=").concat(expires, "; path=/; SameSite=Lax");
            console.log('[AUTH-CTX] Cookie salvo com SameSite=Lax (localhost)');
        }
        else {
            document.cookie = "token=".concat(token, "; expires=").concat(expires, "; path=/; Secure; SameSite=None");
            console.log('[AUTH-CTX] Cookie salvo com Secure; SameSite=None (produção)');
        }
        var cookieVerificado = document.cookie.includes('token=');
        console.log('[AUTH-CTX] Cookie "token" presente após salvar:', cookieVerificado);
    };
    var getAcoesFuncionalidade = function (funcionalidadeParm) {
        var _a;
        if (!funcionalidadeParm)
            return {};
        var permissoes = User === null || User === void 0 ? void 0 : User.permissoes;
        var acoes = (_a = permissoes === null || permissoes === void 0 ? void 0 : permissoes.find(function (funcionalidade) { return funcionalidade.chave === funcionalidadeParm; })) === null || _a === void 0 ? void 0 : _a.acoes;
        var acoesMap = {};
        if (acoes) {
            for (var index = 0; index < acoes.length; index++) {
                var acao = acoes[index];
                if (acao.nome) {
                    acoesMap[acao.nome.toUpperCase()] = true;
                    acoesMap[acao.nome.toLowerCase()] = true;
                }
            }
        }
        if (DEV) {
            console.log("getAcoesFuncionalidade - ".concat(funcionalidadeParm, " - AcoesArray : ").concat(JSON.stringify(acoesMap)));
        }
        return acoesMap;
    };
    var getFuncionalidadeExiste = function (funcionalidadeParm) {
        var acoesFuncionalidade = getAcoesFuncionalidade(funcionalidadeParm);
        return !!Object.keys(acoesFuncionalidade).length;
    };
    var verificarPermissoesPagina = function (pagina, modo) {
        if (DEV) {
            console.log('verificarPermissoesPagina | Pagina:', pagina, '| Modo:', modo);
        }
        var modoUpper = modo === null || modo === void 0 ? void 0 : modo.toUpperCase();
        var paginas = Array.isArray(pagina) ? pagina : [pagina];
        return paginas.some(function (paginaAtual) {
            var acoes = getAcoesFuncionalidade(paginaAtual);
            return modoUpper ? !!acoes[modoUpper] : false;
        });
    };
    var signOutContext = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            localStorage.removeItem('usuario_logado');
            document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            setUser(null);
            return [2 /*return*/];
        });
    }); };
    var getURLBase = function () {
        var dominio = window.location.hostname;
        return dominio.indexOf('localhost') >= 0 ? 'http://localhost:3006' : "https://".concat(dominio);
    };
    var getNomeUsuario = function () {
        return User ? "".concat(User.nome) : '';
    };
    var getMensagens = function () {
        var mensagensAux = __spreadArray([], Mensagens, true);
        setMensagens([]);
        return mensagensAux;
    };
    var addMensagem = function (msg) {
        var mensagensAux = __spreadArray(__spreadArray([], Mensagens, true), [msg], false);
        setMensagens(mensagensAux);
        return mensagensAux;
    };
    return (_jsx(AuthContext.Provider, __assign({ value: {
            User: User,
            NomeUsuario: getNomeUsuario(),
            setUser: setUser,
            DEV: DEV,
            signInContext: signInContext,
            signOutContext: signOutContext,
            getURLBase: getURLBase,
            auth: auth,
            addMensagem: addMensagem,
            getMensagens: getMensagens,
            getAcoesFuncionalidade: getAcoesFuncionalidade,
            getFuncionalidadeExiste: getFuncionalidadeExiste,
            verificarPermissoesPagina: verificarPermissoesPagina,
        } }, { children: children })));
};
export var useAuth = function () { return useContext(AuthContext); };
export default AuthContext;
